/* WOW Apparel: tap a colour dot on a product card to swap the photo in place */
(function () {
  if (window.__wowDots) return;
  window.__wowDots = true;
  var SEL = '.wow-color-dots a, .wow-dot';
  var cache = {};

  function parse(href) {
    try {
      var u = new URL(href, location.origin);
      var m = u.pathname.match(/\/products\/([^\/?#]+)/);
      return m ? { handle: m[1], variant: u.searchParams.get('variant'), base: u.pathname.replace(/\/products\/.*/, '') } : null;
    } catch (e) { return null; }
  }

  function product(info) {
    if (!cache[info.handle]) {
      cache[info.handle] = fetch(info.base + '/products/' + info.handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return cache[info.handle];
  }

  function show(card, mediaId, imgSrc) {
    var slideshow = (card.refs && card.refs.slideshow) || card.querySelector('slideshow-component');
    var target = mediaId && card.querySelector('slideshow-slide[slide-id="' + mediaId + '"]');
    if (slideshow && target) {
      card.querySelectorAll('slideshow-slide[variant-image]').forEach(function (s) { s.hidden = s !== target; });
      target.hidden = false;
      try { slideshow.select({ id: String(mediaId) }, undefined, { animate: false }); return; } catch (e) {}
    }
    if (imgSrc) {
      var img = card.querySelector('slideshow-slide:not([hidden]) img') || card.querySelector('img');
      if (img) {
        img.removeAttribute('srcset');
        img.src = imgSrc + (imgSrc.indexOf('?') > -1 ? '&' : '?') + 'width=900';
      }
    }
  }

  function pick(dot) {
    var card = dot.closest('product-card') || dot.closest('.product-card');
    var wrap = dot.closest('.wow-color-dots, .wow-dots');
    if (!card || !wrap) return;
    var dots = wrap.querySelectorAll('a');
    dots.forEach(function (d) {
      d.classList.toggle('is-active', d === dot);
      d.setAttribute('aria-pressed', d === dot ? 'true' : 'false');
    });
    wrap.setAttribute('data-picked', '');
    var name = dot.getAttribute('title') || '';
    var label = wrap.querySelector('span:last-child');
    if (label && name) label.textContent = name + ' · ' + dots.length + ' colors';

    var href = dot.getAttribute('href');
    if (href) {
      card.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
        if (!wrap.contains(a)) a.setAttribute('href', href);
      });
    }

    // Keep the chosen colour showing when the mouse moves on/off the card
    if (!card.__wowLocked) {
      card.__wowLocked = true;
      card.previewImage = function () {};
      card.resetImage = function () {};
    }

    var info = parse(href || '');
    if (!info || !info.variant) return;
    product(info).then(function (p) {
      if (!p || !p.variants) return;
      var v = p.variants.find(function (x) { return String(x.id) === String(info.variant); });
      if (!v) return;
      var fm = v.featured_media;
      show(card, fm && fm.id, (fm && fm.preview_image && fm.preview_image.src) || v.featured_image && v.featured_image.src);
    });
  }

  document.addEventListener('click', function (e) {
    var dot = e.target.closest && e.target.closest(SEL);
    if (!dot) return;
    e.preventDefault();
    e.stopPropagation();
    pick(dot);
  }, true);

  // Warm the product data as soon as a shopper reaches for a dot
  function warm(e) {
    var dot = e.target.closest && e.target.closest(SEL);
    if (!dot) return;
    var info = parse(dot.getAttribute('href') || '');
    if (info) product(info);
  }
  document.addEventListener('pointerover', warm, { passive: true });
  document.addEventListener('touchstart', warm, { passive: true });
})();
